import { Grid2 as Grid } from "@mui/material";
import { useFormat } from "@sinch/core/hooks/format";
import { DateTime } from "luxon";
import React, { memo } from "react";
import { testIds } from "./constants";

export const DayTimePickerOption = memo(
  ({ option, timePoint }: { option: DateTime; dateInOption?: boolean; timePoint?: DateTime | null }) => {
    const { time, duration } = useFormat();

    if (!option) {
      return;
    }
    const jsDate = option.toJSDate();
    return (
      <Grid container spacing={1} wrap="nowrap">
        <Grid data-cy={testIds.timeInputOptionTime} size="grow" sx={{ minWidth: "3em" }}>
          {time.short(jsDate, { timeZone: "UTC" })}
        </Grid>
        {timePoint && (
          <Grid
            size="grow"
            sx={{
              color: "text.disabled",
              fontSize: "smaller",
            }}
          >
            ({duration.narrow(option.diff(timePoint, "seconds").seconds)})
          </Grid>
        )}
      </Grid>
    );
  }
);
DayTimePickerOption.displayName = "TimePickerOption";
